angular.module('impactx.search').directive('ixMinimizedSearchFilters', function () {
    return {
        scope: {
            trns: '=',
            keepToggleSearch: '=',
            fixedFilters: '=',
            facetResults: '=',
            searchInput: '=',
            showSearch: '=',
            toolbarColor: '@',
            toggleDrillDown: '&',
            search: '&',
            clearSearchInput: '&'
        },
        controller: 'MinimizedSearchFiltersCtrl',
        controllerAs: 'MinimizedSearchFiltersCtrl',
        restrict: 'E',
        templateUrl: 'modules/search/templates/minimizedsearchfilters.tmpl.html'
    };
});